"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HistogramRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function DefaultColumn(props) {
  return _react.default.createElement("rect", (0, _extends2.default)({
    fill: "black"
  }, props.columnProps));
}

var HistogramRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(HistogramRenderable, _React$PureComponent);

  function HistogramRenderable() {
    (0, _classCallCheck2.default)(this, HistogramRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(HistogramRenderable).apply(this, arguments));
  }

  (0, _createClass2.default)(HistogramRenderable, [{
    key: "buildColumn",
    value: function buildColumn(row, index, orientation) {
      var Column = this.props.column;
      var x, y, width, height;

      if (orientation === 'vertical') {
        x = row.x0;
        y = row.y;
        width = row.x1 - row.x0;
        height = this.props.height - row.y;
      } else {
        x = 0;
        y = row.y0;
        width = row.x;
        height = row.y1 - row.y0;
      }

      return _react.default.createElement(Column, {
        key: index,
        columnProps: (0, _objectSpread2.default)({
          x: x,
          y: y,
          width: width,
          height: height
        }, this.props.columnProps),
        dimensions: row,
        index: index,
        data: this.props.data,
        scaledData: this.props.scaledData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var sampleRow = this.props.scaledData[0];
      var orientation = this.props.orientation || sampleRow.hasOwnProperty('x0') ? 'vertical' : sampleRow.hasOwnProperty('y0') ? 'horizontal' // eslint-disable-next-line no-console
      : console.error('Histogram renderable must be supplied binned data');
      if (!orientation) return null;
      return _react.default.createElement("g", null, this.props.scaledData.map(function (row, index) {
        return _this.buildColumn(row, index, orientation);
      }));
    }
  }]);
  return HistogramRenderable;
}(_react.default.PureComponent);

exports.HistogramRenderable = HistogramRenderable;
(0, _defineProperty2.default)(HistogramRenderable, "propTypes", {
  height: _propTypes.default.number.isRequired,
  width: _propTypes.default.number,
  data: _propTypes.default.object,
  scaledData: _propTypes.default.arrayOf(_propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })).isRequired,
  columnProps: _propTypes.default.object,
  column: _propTypes.default.func,
  orientation: _propTypes.default.string
});
(0, _defineProperty2.default)(HistogramRenderable, "defaultProps", {
  columnProps: {},
  column: DefaultColumn
});

var Histogram =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Histogram, _React$Component);

  function Histogram() {
    (0, _classCallCheck2.default)(this, Histogram);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Histogram).apply(this, arguments));
  }

  (0, _createClass2.default)(Histogram, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(HistogramRenderable, this.props);
    }
  }]);
  return Histogram;
}(_react.default.Component);

exports.default = Histogram;
(0, _defineProperty2.default)(Histogram, "chartType", 'canvas');
(0, _defineProperty2.default)(Histogram, "propTypes", {
  columnProps: _propTypes.default.object,
  column: _propTypes.default.func,
  orientation: _propTypes.default.string
});